module.exports = __webpack_public_path__ + "static/banner-alltopasia-promotion-cover--6.5%-per-week-d7b814da9b780e9f8e9f834da22fedc4.jpg";